export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Cyrillic-418cb682dbf4030a1b340a228c2cabcc.woff2";